import { HTTP } from '../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { httpError } from '../../models/httpError';
import { getField, updateField } from 'vuex-map-fields';
import MenuPermission from '../../models/MenuPermission';

const state = {
  rows: [],
  permissionSet: {},
  message: new httpError(),
  menuItems: [],
};

const getters = {
  rows: state => {
    return state.rows;
  },
  message: state => {
    state.message;
  },
  permissionSet: state => {
    state.permissionSet;
  },
  menuItems: state => {
    state.menuItems;
  },
  getField,
};

const actions = {
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  getMenuPermissions({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('permission/GetAuthorisedMenuPermissions')
        .then(res => {
          if (res.status == 200) {
            let permissions = res.data.data.map(item => {
              return new MenuPermission(item);
            });
            commit('setMenuPermissions', permissions);
            resolve(res.data.data);
          } else commit('reset');
          dispatch(
            'setMessage',
            new httpError({ message: 'Retreived OK', httpStatus: 200 })
          );
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getPermissionGroups({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('permission/GetAllPermissionGroups').then(data => {
        let result = data.data.data;
        if (result) {
          let temp = result.map(x => {
            return { group: x, grant: true };
          });
          commit('setPermissionSet', temp);
          resolve(temp);
        }
      });
    }).catch(err => {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      reject(err);
    });
  },
  saveMenuPermissions({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post('permission/UpsertMenuPermission', data)
        .then(res => {
          if (res.status == 200) dispatch('getMenuPermissions');

          dispatch(
            'setMessage',
            new httpError({ message: 'Saved Successfully', httpStatus: 200 })
          );
          resolve(res.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error saving',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  deleteMenuPermission({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post('permission/DeleteMenuPermission', data)
        .then(res => {
          if (res.status == 200) dispatch('getMenuPermissions');

          dispatch(
            'setMessage',
            new httpError({ message: 'Deleted Successfuly', httpStatus: 200 })
          );
          resolve(res.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error deleting',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
};

const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  setMenuPermissions(state, data) {
    state.rows = data;
  },
  setPermissionSet(state, data) {
    state.permissionSet = new MenuPermission();
    state.permissionSet.permissions = data;
  },
  reset(state) {
    state.rows = [];
    state.message = new httpError();
  },
  updateField,
};

const modules = {};
export const { mapFields: mapMenuPermissionsFields } = createHelpers({
  getterType: `menuPermissions/getField`,
  mutationType: `menuPermissions/updateField`,
});

export const {
  mapMultiRowFields: mapmenuPermissionsMultiRowFields,
} = createHelpers({
  getterType: 'menuPermissions/getField',
  mutationType: 'menuPermissions/updateField',
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
